module.exports = __webpack_public_path__ + "static/media/ai_method.7e030d76.svg";